import script from "./ParamsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ParamsView.vue?vue&type=script&setup=true&lang=ts"

import "./ParamsView.vue?vue&type=style&index=0&id=690978a3&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-690978a3"]])

export default __exports__